module.exports = __webpack_public_path__ + "media/images/color_admin_v3/product/product-preview-iphone-8554eb98517ff6f8ab1a18c6c91ffa4e.png";